export default {
  tabbar_home: "首頁",
  tabbar_order: "訂單",
  tabbar_my: "我的"
}